import { render } from "./PageLoader.vue?vue&type=template&id=5137e9d4&scoped=true"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"

import "./PageLoader.vue?vue&type=style&index=0&id=5137e9d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5137e9d4"]])

export default __exports__